import { formatCents } from "../../utils/directorFormat";

const movementTone = (value) => (
  value > 0 ? "positive" : value < 0 ? "negative" : "neutral"
);

const CashflowSummaryGrid = ({ summary }) => {
  if (!summary) return null;
  const items = [
    { key: "inflow", label: "Entradas do período", value: summary.inflowCents, tone: "inflow" },
    { key: "outflow", label: "Saídas do período", value: summary.outflowCents, tone: "outflow" },
    {
      key: "accumulated",
      label: "Fluxo líquido acumulado",
      value: summary.endingAccumulatedNetFlowCents,
      tone: movementTone(summary.endingAccumulatedNetFlowCents),
    },
  ];
  return <section className="director-metric-grid" aria-label="Resumo do movimento financeiro">
    {items.map((item) => <article
      className={`director-metric director-metric--${item.tone}`}
      key={item.key}
    >
      <span>{item.label}</span>
      <strong>{formatCents(item.value)}</strong>
    </article>)}
  </section>;
};

export default CashflowSummaryGrid;
